/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * notification_service
 * OpenAPI spec version: 0.1.0
 */

/**
 * The type of an entity in Macro
 */
export type EntityType = (typeof EntityType)[keyof typeof EntityType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EntityType = {
  user: 'user',
  chat: 'chat',
  channel: 'channel',
  channel_message: 'channel_message',
  document: 'document',
  project: 'project',
  email_thread: 'email_thread',
  calendar_event: 'calendar_event',
  team: 'team',
  call: 'call',
  foreign_entity: 'foreign_entity',
  static_file: 'static_file',
  crm_company: 'crm_company',
  crm_contact: 'crm_contact',
  crm_pipeline: 'crm_pipeline',
  reminder: 'reminder',
  skill: 'skill',
  agent_session: 'agent_session',
  scheduled_action: 'scheduled_action',
  initiative: 'initiative',
  database: 'database',
  database_row: 'database_row',
  form: 'form',
  external_chat: 'external_chat',
} as const;
